export default __webpack_public_path__ + "static/brand-logo-premium-country-pubs-9d05d0ebc22f31b60e29e3a1132d02ce.png";